import { Action } from "redux"
import { IShortcut } from "../../models"

export const INITIALIZE = "SHORTCUTS_INITIALIZE"
export const SET_INITIALIZED = "SHORTCUTS_SET_INITIALIZED"

export const initializeShortcuts = (): Action => ({ type: INITIALIZE })

export const setInitialized = (): Action => ({ type: SET_INITIALIZED })

export const FILTER_SHORTCUTS = "SHORTCUTS_FILTER_SHORTCUTS"
export const RECEIVE_SHORTCUTS = "SHORTCUTS_RECEIVE_SHORTCUTS"
export const REQUEST_SHORTCUTS = "SHORTCUTS_REQUEST_SHORTCUTS"

export interface FilterShortcuts extends Action {
    filter: string
}

export interface ReceiveShortcuts extends Action {
    shortcuts: IShortcut[]
}

export const requestShortcuts = (): Action => ({ type: REQUEST_SHORTCUTS })

export const filterShortcuts = (filter: string): FilterShortcuts => ({
    type: FILTER_SHORTCUTS,
    filter,
})

export const receiveShortcuts = (shortcuts: IShortcut[]): ReceiveShortcuts => ({
    type: RECEIVE_SHORTCUTS,
    shortcuts: shortcuts,
})

export const mapDispatchToProps = {
    initializeShortcuts,
    setInitialized,
    filterShortcuts,
    receiveShortcuts,
    requestShortcuts,
}

export type DispatchProps = typeof mapDispatchToProps
